import { defineStore } from 'pinia';

export const useSocialStore = defineStore('social', {
  state: () => ({
    socials: null,
  }),
  actions: {
    init(socials) {
      if (!socials) return;
      this.socials = socials;
    },
  },
});
